import { featuresData } from '@/mocks/homeData';

export default function FeaturesSection() {
  return (
    <section id="features" className="w-full py-16 md:py-20 bg-background-100">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 text-center mb-3">平台特色</h2>
        <p className="text-sm text-foreground-500 text-center mb-12">为什么选择桃子视频作为您的在线观影入口</p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-5">
          {featuresData.map((feature, idx) => (
            <div key={idx} className="group p-5 bg-background-50 rounded-lg border border-background-200/60 text-center hover:border-primary-300/60 transition-all">
              <div className="w-12 h-12 mx-auto mb-4 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors">
                <i className={`${feature.icon} text-xl`}></i>
              </div>
              <h3 className="text-sm font-semibold text-foreground-800 mb-2">{feature.title}</h3>
              <p className="text-xs text-foreground-500 leading-relaxed">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}